import { AdminUpdateAppEndAction } from "../actions";
import { AdminState } from "../state";

import { updateAppInState } from "./Common";

export function updateApp(state: AdminState, action: AdminUpdateAppEndAction): AdminState {
    return updateAppInState(state, action);
}
